var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconScreenShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_small_source_screen",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .screen-share-class-a {\n        fill: none !important;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "screen-share-class-a",
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 31,
    height: 31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M22.5,21.325a2.328,2.328,0,0,0,2.239-2.4L24.75,5.4A2.329,2.329,0,0,0,22.5,3H4.5A2.322,2.322,0,0,0,2.25,5.4V18.923a2.329,2.329,0,0,0,2.25,2.4H0v2.4H27v-2.4Zm-18-2.4V5.4h18V18.935Zm10.153-8.89c-4.376.649-6.12,3.843-6.75,7.05,1.564-2.246,3.622-3.267,6.75-3.267v2.63l4.5-4.492-4.5-4.48Z",
    transform: "translate(2 2)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconScreenShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_screen_share.4ad5a699a4f9148713337c33874a4463.svg";